import './CustomerLeadStepDone.scss';

import LogoText from 'src/assets/logo-text.svg?react';

export function CustomerLeadStepDone() {
  return (
    <div className="customer-lead-step-done__layout">
      <div className="customer-lead-step-done__layout__left" />
      <div className="customer-lead-step-done__layout__center">
        <div className="customer-lead-step-done__layout__center__header">
          <div className="customer-lead-step-done__layout__center__header__logo">
            <div className="customer-lead-step-done__layout__center__header__logo-icon" />
            <LogoText className="customer-lead-step-done__layout__center__header__logo-text" />
          </div>
        </div>

        <div className="customer-lead-step-done__layout__center__content">
          <div className="customer-lead-step-done__layout__center__title">Thank you!</div>
          <div className="customer-lead-step-done__layout__center__text">&nbsp;</div>
        </div>
      </div>
      <div className="customer-lead-step-done__layout__right" />
    </div>
  );
}
